import * as fromEnums from '../../enums';
import * as fromModels from '../../models';

import { Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/dossier.status.service.ts                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon May 06 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { TranslateService } from '@ngx-translate/core';

/**
 * The dossier status service
 */
@Injectable({
    providedIn: 'root'
})
export class DossierStatusService {

    /**
     * The constructor
     */
    constructor(private translateService: TranslateService, private logger: NGXLogger) { }

    /**
     * Get dossier statuses
     */
    getDossierStatus(isoCode: string): Observable<fromModels.DossierStatus[]> {

        if (isoCode === undefined) {
            isoCode = 'it';
        }
        return this.translateService.getTranslation(isoCode).pipe(
            map((translations) => {
                const dossierStatusArray: fromModels.DossierStatus[] = [];
                const values = Object.keys(fromEnums.DossierStatusEnum).map(e => fromEnums.DossierStatusEnum[e]);
                values.forEach((value: string) => {
                    if (isNaN(Number.parseInt(value))) {
                        const dossierStatus: fromModels.DossierStatus = new fromModels.DossierStatus();
                        dossierStatus.status = fromEnums.DossierStatusEnum[value];
                        dossierStatus.description = translations['status_dossier_' + value.toLowerCase()];
                        dossierStatusArray.push(dossierStatus);
                    }
                });
                return dossierStatusArray;
            }),
            first()
        );
    }


}
